<template lang="pug">
section
  s-page-title(title='Отчет по принятым квартирам')
  v-container(grid-list-xl fluid class='pa-0')
    v-layout(wrap)
      v-flex(xs12 sm4)
        s-checklist-complex-picker(
          :value='dataFilter.complex'
          :return-object='true'
          @change='changeComplex'
          label='Выберите комплекс'
          clearable
        )
      v-flex(xs12 sm8 v-if='dataFilter.complex')
        s-checklist-object-picker(
          :filter='x => x.complex_id == dataFilter.complex.id'
          :value='dataFilter.object'
          @change='changeObject'
          clearable
        )
  v-card

    v-alert(
      :value="true"
      color="warning"
      icon="warning"
      outline
    ) В отчете отображаются только пункты чеклиста, которые НЕ БЫЛИ отмечены пользователями как ВЫПОЛНЕНО!
  v-tabs(color='dark' slider-color='primary' v-model='dataFilter.activeTab' @change='setActiveTab')
      v-tab Отчет
      v-tab-item(:transition='false' :reverse-transition='false')
        v-card
          v-data-table(
              :loading='isLoading'
              :headers='headers'
              :items='report.checkList'
              hide-actions
              dense
            )
              template(slot='items' slot-scope='props')
                tr(class='with-pointer')
                  td() {{ props.item.id }}
                  td() {{ props.item.name }}
                  td()
                  td()
                    div(v-for="comment in props.item.comments") {{comment}}
                tr(v-for="(subItem) in props.item.sub_categories" :key="subItem.id")
                  td() {{ subItem.id }}
                  td()
                    div(class='sub-item') {{ subItem.name }}
                  td() {{ subItem.node=='item' ? subItem.count : '' }}
                  td()
                    div(v-for="comment in subItem.comments") {{comment}}
      v-tab Пользователи
      v-tab-item(:transition='false' :reverse-transition='false')
        v-card
          v-data-table(
              :loading='isLoading'
              :headers='headersSessions'
              :items='report.sessions'
              hide-actions
              dense
            )
              template(slot='items' slot-scope='props')
                tr()
                  td() {{ props.item.id }}
                  td()
                    div(class='bolder') +7 {{ props.item.phone }}
                    div {{ props.item.user_name }}
                  td(:class='props.item.state')
                    div(class='bolder') {{ props.item.state_name }}
                    div {{ props.item.updated_at }}
                  td()
                    div(class='bolder') {{ props.item.complex_name + ', ' + props.item.object_name + ', кв (пом) №' + props.item.room }}
                    div {{ 'Подъезд ' + props.item.entrance + ', Этаж ' + props.item.floor }}
                  td(class='text-xs-right wrapless crud-tools')
                    v-btn(icon @click='onOpenUser(props.item)')
                      v-icon(small) format_list_bulleted

</template>

<script>
import http from '@/http'
import { mapState, mapMutations } from 'vuex'

export default {
  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '4%',
        sortable: false
      },
      {
        text: 'Категория',
        align: 'left',
        value: 'fio',
        width: '33%',
        sortable: false
      },
      {
        text: 'Количество',
        align: 'left',
        value: 'position',
        width: '15%',
        sortable: false
      },
      {
        text: 'Комментарии',
        align: 'left',
        value: 'position',
        width: '33%',
        sortable: false
      }
    ],
    headersSessions: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '4%',
        sortable: false
      },
      {
        text: 'Пользователь',
        align: 'left',
        value: 'fio',
        width: '20%',
        sortable: false
      },
      {
        text: 'Статус/Время изменения',
        align: 'left',
        value: 'position',
        width: '15%',
        sortable: false
      },
      {
        text: 'Объект',
        align: 'left',
        value: 'position',
        width: '33%',
        sortable: false
      },
      {
        text: '',
        align: 'right',
        value: 'position',
        width: '33%',
        sortable: false
      }
    ],
    isLoading: false,
    report: {}
  }),

  created() {
    this.fetch()
  },

  methods: {
    async fetch() {
      this.isLoading = true

      const params = {}
      const { object, complex } = this.dataFilter

      if (object && object > 0) {
        params.objectId = object
      }

      if (complex && complex.id) {
        params.complexId = complex.id
      }

      try {
        this.report = (
          await http.get('/checklist/report', {
            params: params
          })
        ).data
      } catch (e) {
        this.$root.showSnack('Не удалось загрузить отчет')
      }

      this.isLoading = false
    },

    refreshReport() {
      this.fetch()
    },

    changeComplex(complex = null) {
      this.setDataFilter({ complex, object: null })
      this.fetch()
    },
    changeObject(object = null) {
      this.setDataFilter({ object })
      this.fetch()
    },

    onOpenUser({ id } = {}) {
      this.$router.push({
        name: 'Checklist.Report.User',
        params: { sessionId: id }
      })
    },
    setActiveTab(index) {
      this.setDataFilter({ activeTab: index })
    },

    ...mapMutations('checklist/report', ['setDataFilter'])
  },

  computed: mapState('checklist/report', ['dataFilter'])
}
</script>

<style scoped>
.sub-item {
  margin-left: 20px;
}
.bolder {
  font-weight: 500;
  font-size: 15px;
}
.in_progress .bolder {
  color: red;
}

.finished .bolder {
  color: green;
}
</style>
